import React from 'react';
import './LoginLoading.scss';
// import { ReactComponent as LoginLoadingImage } from '../../assets/images/loading-image.svg';

interface LoginLoadingProps {
  country: string;
  name: string;
  retry: number;
}
function LoginLoading({ country, name, retry }: LoginLoadingProps) {
  return (
    <div className="login-loading-container">
      <div className="login-loading-content">
        <div className="login-loading-main-text">Hi{name ? <span className="fade-in-text">{` ${name}`}</span> : <></>}!</div>
        <div className="login-loading-sub-text">
          Signing you into EA Company Store {country ? <span className="fade-in-text">({country})</span> : <></>} {retry > 1 ? (<span>(Retry#{retry})</span>) : (<></>)}...
        </div>
      </div>
    </div>
  );
}

export default LoginLoading;
